module.exports = __webpack_public_path__ + "static/media/680px_DianaConnolly_Study_Recruitment.4f1ba89e.gif";